import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';
import CustomSelect from 'Common/CustomSelect/CustomSelect';
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader';
import ReactPortal from 'Components/ReactPortal/ReactPortal';
import api from 'http';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';

const TaskLinkTypePopup = ({ onClose }) => {
    const [linkType, setLinkType] = useState("")
    const [allLinks, setAllLinks] = useState([])
    const [loader, setLoader] = useState(false)
    const chargesRight = useSelector((state) => state.userAuth.userinfo?.userModuleRights)?.charges
    const handleChange = (e) => {
        setLinkType(e.target.value)
        if (e.target.value) {
            onClose(e.target.value, e.target.options[e.target.selectedIndex].innerText)
        }
    }

    useEffect(() => {
        (async () => {

            try {
                setLoader(true)
                const response = await api.get(`${process.env.REACT_APP_TC_TASK}/api/DropDown/FindTaskLinkType`)

                if (!chargesRight) {
                    response.data.dataModel = response.data.dataModel.filter((item) => item.label !== "Claim")
                }
                setAllLinks(response.data.dataModel)

            } catch (error) {
                ErrorHandlingMessage(error)
            }
            finally {
                setLoader(false)
            }
        })();
    }, [])

    return (
        <>
            <ReactPortal wrapperId="AddTaskLinkPopup">
                {loader && <FullPageLoader allowFullScreen />}
                <div data-te-modal-init className="fixed left-0 top-0 z-[10] h-full w-full overflow-y-auto overflow-x-hidden outline-none" id="exampleModalScrollable" tabIndex={-1} aria-labelledby="exampleModalScrollableLabel" style={{ display: 'block' }} aria-modal="true" role="dialog" data-te-open="true">
                    <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
                    <div data-te-modal-dialog-ref className="pointer-events-none flex items-center relative h-[calc(100%-1rem)] w-auto translate-y-[-50px] transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[520px] transform-none opacity-100">
                        <div className="pointer-events-auto p-5 relative flex justify-between max-h-[100%] w-full flex-col overflow-hidden rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600">
                            <div className='pb-3 text-2xl font-semibold border-b'>Task Link</div>
                            <div>
                                <div className='grid grid-cols-12 gap-4 my-4'>
                                    <div className='col-span-12'>
                                        <CustomSelect onChange={handleChange} name="taskType" value={linkType} label={"Link Type"} >
                                            <option value={""}>Please Select</option>
                                            {allLinks.map((link) => <option key={link.id} value={link.value}>{link.label}</option>)}
                                        </CustomSelect>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="relative overflow-y-auto">
                                //  you want any content to scroll then add that content in this div
                            </div> */}
                            <div className="flex flex-wrap items-center justify-end flex-shrink-0 gap-2 ">
                                <CustomButtonNew label={"Cancel"} variant={"outline"} onClick={() => onClose("")} />
                            </div>
                        </div>
                    </div>
                </div>

            </ReactPortal>
        </>

    )
}

export default TaskLinkTypePopup